//import store from "../../store";
const medienRoutes = [
  {
    path: "/Medien",
    component: () =>
      import(
        /*webpackChunkName: 'component-homepage' */ "@/pages/Medien.vue"
      ), 
      
  },
];

export default medienRoutes;
